<template>
	<v-dialog
			content-class="additionalPaymentsWrapper"
			width="340"
			:value="dialog"
			persistent
			transition="dialog-bottom-transition"
	>
		<div class="additionalPayments">
			<div class="additionalPayments_header">
				<span>{{ additionalPaymentId ? 'Edit': 'Add' }} additional payment</span>
				<button type="button" @click="onCloseDialog">
					<svg-sprite width="20" height="20" icon-id="close"></svg-sprite>
				</button>
			</div>
			<div class="additionalPayments_body">
				<field
						:class-error="getError('description')"
						margin="0 0 10px 0"
						width="300px"
						label="Description"
						placeholder="Some text...."
						@updateInput="onInput($event, 'description')"
						:setInputValue="description"
						isTextarea
						is-required
				></field>
				<field
						:class-error="getError('amount')"
						margin="0 0 10px 0"
						width="300px"
						type="number"
						label="Amount"
						placeholder="Enter value"
						:setInputValue="amount"
						@updateInput="onInput($event, 'amount')"
						is-required
				></field>
				<field
						:class-error="getError('categori_id')"
						margin="0"
						width="300px"
						label="Category"
						placeholder="Select category"
						@updateSelect="onAutocomplete($event, 'categori_id')"
						:autocompleteValue="categori_id"
						:items="category"
						item-text="name"
						:isClearable="false"
						is-select
						is-required
				></field>
			</div>
			<button-groups
					apply-text="submit"
					@updateBtnClose="onCloseDialog"
					@updateSave="onSave"
			></button-groups>
		</div>
		<preload v-if="additionalPaymentsPreloader"></preload>
	</v-dialog>
</template>

<script>
import { mapActions } from "vuex";
// shared
import ButtonGroups from "@/shared/ButtonGroups/ButtonGroups";
import Preload from "@/shared/Preload/Preload";
// validations
import { required } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";

export default {
	name: "AdditionalPayments",
	mixins: [ validationMixin ],
	props: {
		category: Array,
		itemId: Number,
		additionalPaymentData: Object
	},
	components: {
		ButtonGroups,
		Preload
	},
	data: () => ({
		dialog: true,
		additionalPaymentId: null,
		additionalPaymentsPreloader: false,
		description: '',
		amount: null,
		categori_id: null
	}),
	validations: {
		description: { required },
		amount: { required },
		categori_id: { required }
	},
	methods: {
		...mapActions([ 'onAddition', 'setAlert' ]),
		getError(key) {
			return this.$v[key]?.$error;
		},
		onCloseDialog() {
			this.$emit('updateClose');
		},
		async onSave() {
			this.$v.$touch();
			if (!this.$v.$error) {
				const { categori_id, amount, description } = this.$data;
				const values = { categori_id, amount, description, statements_id: this.itemId };
				this.additionalPaymentsPreloader = true;
				const id = this.additionalPaymentData?.id;
				const textSuccess = id ? "Successfully updated item" : "Successfully added item";
				const { status } = await this.onAddition({ values, id });

				if (status) {
					this.setAlert({ type: "success", message: textSuccess });
				} else {
					this.setAlert({ type: "error", message: "Item added error" });
				}

				this.onCloseDialog();
			} else {
				this.setAlert({ type: "error", message: "Saving error" });
			}

			this.additionalPaymentsPreloader = false;
		},
		onInput({ value }, key) {
			this[key] = value;
		},
		onAutocomplete({ value }, key) {
			this[key] = value?.id ?? value;
		}
	},
	mounted() {
		if (this.additionalPaymentData) {
			const { id, description, categori_id, amount } = this.additionalPaymentData;
			this.additionalPaymentId = id;
			this.description = description;
			this.categori_id = categori_id;
			this.amount = amount;
		}
	}
};
</script>

<style lang="scss">
/*	.additionalPaymentsWrapper {
		padding: 20px;
		background: #1C1C28;
		box-shadow: 2px 4px 10px rgba(0, 0, 0, 0.3);
	}*/
</style>
<style scoped lang="scss">
		.additionalPayments {
			padding: 20px;
			background: #1C1C28;
			box-shadow: 2px 4px 10px rgba(0, 0, 0, 0.3);

			&_body {
				margin-bottom: 20px;
			}

			.groupField_wrap {
				position: relative;
				display: flex;
				align-items: flex-start;
				padding: 20px;
				background: #1C1C28;
				z-index: 1;

				&.notPadding {
					padding: 0;
				}
			}

			.boxBtn {
				transition: all .3s ease;
				color: #19BC38;
				&.opened {
					transform: rotate(180deg);
				}

				&:disabled {
					color: var(--card-color);
				}
			}

			.boxDropDown {
				background: #1C1C28;
				position: absolute;
				left: -10px;
				right: 20px;
				bottom: -10px;
				transform: translateY(100%);
				font-weight: 400;
				font-size: 14px;
				line-height: 20px;

				&_item {
					display: flex;
					align-items: center;
					margin: 10px;
				}

				&:after {
					content: '';
					left: 10px;
					right: 10px;
					position: absolute;
					top: 0;
					border-top: 1px solid #19BC38;
				}
			}

			[type="button"] {
				line-height: 1;
			}

			.flexBlock {
				display: flex;
				align-items: center;
				justify-content: space-between;
			}

			&_header {
				display: flex;
				justify-content: space-between;
				align-items: center;
				margin-bottom: 20px;
				font-weight: 500;
				font-size: 20px;
				line-height: 24px;
				letter-spacing: 0.25px;
				color: #FFFFFF;
			}

			.fieldBlock {
				background: #1C1C28;
				border-radius: 4px;
				margin-bottom: 20px;
			}
		}
</style>
